// extracted by mini-css-extract-plugin
export default {"DocumentsViewContainer":"Documentsview_DocumentsViewContainer__Bg+wf","DocumentsViewItem":"Documentsview_DocumentsViewItem__02p4r"};